import { Navigate, Routes, Route, useParams } from 'react-router-dom';
import RespondentApp from './respondent/RespondentApp';
import WizardApp from './wizard/WizardApp';
import ResumePage from './wizard/ResumePage';
import CreatorApp from './creator/CreatorApp';

/**
 * Routeur racine.
 *
 * - `/s/:slug/wizard` : NOUVEAU parcours wizard (RESPONDENT_WIZARD_SPEC v1.3 MVP).
 * - `/s/:slug/legacy` : ancien parcours répondant (toutes questions sur 1 page).
 *   Conservé pour les tests E2E et comme fallback ; **plus utilisé en diffusion**.
 * - `/s/:slug`        : REDIRECTION vers `/s/:slug/wizard` (parcours par défaut).
 *   Couvre les liens et QR codes déjà partagés à l'audience avant la migration.
 * - `/s/:slug/reprendre` : reprise multi-appareil par code.
 * - `/*`              : app créateur (login + workspaces).
 */
function SurveyRoot(): JSX.Element {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return <Navigate to="/" replace />;
  return <Navigate to={`/s/${encodeURIComponent(slug)}/wizard`} replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/s/:slug/wizard" element={<WizardApp />} />
      <Route path="/s/:slug/reprendre" element={<ResumePage />} />
      {/* Ancien parcours répondant — accès explicite uniquement (E2E + fallback). */}
      <Route path="/s/:slug/legacy/*" element={<RespondentApp />} />
      <Route path="/s/:slug/legacy" element={<RespondentApp />} />
      {/* `/s/:slug` → redirect wizard (capture les liens & QR pré-migration). */}
      <Route path="/s/:slug" element={<SurveyRoot />} />
      <Route path="/*" element={<CreatorApp />} />
    </Routes>
  );
}
